module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjE2MCIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIiAKICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxjaXJjbGUgY3g9IjgiIGN5PSI4IiByPSI0LjI5NzYiIGZpbGw9IiM4RTJDRUEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pupil.svg
// module id = Xrod
// module chunks = 1